import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import AppPageHeader from '../../components/AppPageHeader'
import PageTitle from '../../components/PageTitle'
import DashboardLayout from '../../layouts/DashboardLayout'
import TabHeader from '../../components/reports/TabHeader'
import { Button, DatePicker } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import TableComponent from '../../components/Common/TableComponent'
import { SlFolderAlt } from 'react-icons/sl'
import ReportCreateModal from './ReportCreateModal'
import { AppTable } from '../../components/AppTable/AppTable'

const ReportPage = ({
  reportStore,
  history,
  loadingAnimationStore,
  documentAccessibilityStore,
}) => {
  const { type } = reportStore
  const selectedYear = sessionStorage.getItem('selectedYear')
  const [currentYear, setCurrentYear] = useState(
    selectedYear ? selectedYear : moment().format('YYYY')
  )
  const [showAddReport, setShowAddReport] = useState(false)
  const [dataDoc, setDataDoc] = useState([])

  const onChange = (date, dateString) => {
    setCurrentYear(dateString)
    sessionStorage.setItem('selectedYear', dateString)
  }

  const handleCancelAddReport = useCallback(() => {
    setShowAddReport(false)
  }, [])

  useEffect(() => {
    const fetchDocumentAccessibilities = async () => {
      try {
        loadingAnimationStore.showSpinner(true)
        const response = await documentAccessibilityStore.getDocumentAccessibilityByTypeAndAccess(
          'RISK_REPORT',
          'REPORT'
        )
        setDataDoc(response.data)
      } catch (error) {
        console.log(error)
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }

    fetchDocumentAccessibilities()
  }, [documentAccessibilityStore, loadingAnimationStore])

  const listData = [
    {
      name: `Quý I - ${currentYear}`,
      title: 'Tháng 4,5,6',
      key: 'q1',
    },
    {
      name: `Quý II - ${currentYear}`,
      title: 'Tháng 7,8,9',
      key: 'q2',
    },
    {
      name: `Quý III - ${currentYear}`,
      title: 'Tháng 10,11,12',
      key: 'q3',
    },
    {
      name: `Quý IV - ${currentYear}`,
      title: 'Tháng 1,2,3',
      key: 'q4',
    },
    {
      name: `Cả năm ${currentYear}`,
      title: 'Tháng 1,2,34,5,6,7,8,9,10,11,12',
      key: 'all',
    },
  ]

  const tableColumns = [
    {
      title: 'Kỳ báo cáo',
      key: 'name',
      render: record => (
        <div title={record.title}>
          <SlFolderAlt style={{ marginRight: 8 }} />
          {record.name}
        </div>
      ),
    },
  ]
  return (
    <DashboardLayout>
      <Helmet>
        <title>Báo cáo | Danh sách Báo cáo</title>
      </Helmet>
      <AppPageHeader
        title="Danh sách Báo cáo"
        addon={
          <div>
            <DatePicker
              style={{ marginRight: '5px' }}
              onChange={onChange}
              defaultValue={selectedYear ? moment(selectedYear) : moment()}
              picker="year"
            />
            {dataDoc[0]?.status === true && (
              <Button
                onClick={() => {
                  setShowAddReport(true)
                }}
                type={'primary'}
                icon={<PlusOutlined />}>
                Tạo mới
              </Button>
            )}
          </div>
        }
      />

      <ContentBlockWrapper style={{ minHeight: 600 }}>
        <TabHeader />
        <AppTable
          onRow={record => {
            return {
              onClick: () =>
                history.push(
                  `/report/${
                    type === 'DINH_KY' ? 'periodic' : 'extraordinary'
                  }?quarterly=${record.key}-${currentYear}`
                ),
            }
          }}
          rowKey={record => record.code}
          dataSource={listData}
          columns={tableColumns}
          pagination={false}
        />
      </ContentBlockWrapper>

      {showAddReport && (
        <ReportCreateModal
          modalVisible={showAddReport}
          currentYear={currentYear}
          onCancel={handleCancelAddReport}
          isAdmin={true}
          typeCompany={type}
          loadAdminsList={''}
          editReport={null}
        />
      )}
    </DashboardLayout>
  )
}

export default inject(
  'reportStore',
  'loadingAnimationStore',
  'documentAccessibilityStore'
)(observer(ReportPage))
